import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Bolt0_string$Bolt0 from "bolt0/./bolt0_string.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function Make(Record_param, Label) {
  var Private = {
    Record_param: Record_param,
    Label: Label
  };
  var $$Error = {};

  var distance = Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Euclidean",
  /* :: */
  ["Maximum",
  /* :: */
  ["Manhattan",
  /* :: */
  ["PearsonCorrelation",
  /* :: */
  ["SpearmanCorrelation",
  /* :: */
  ["KendallCorrelation",
  /* [] */
  0]]]]]]);

  var linkage = Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Complete",
  /* :: */
  ["Single",
  /* :: */
  ["Mean",
  /* :: */
  ["Centroid",
  /* :: */
  ["Ward",
  /* [] */
  0]]]]]);

  var tag = "Hierarchical";

  var distance$1 = Curry._1(Label.named_exn, "distance");

  var linkage$1 = Curry._1(Label.named_exn, "linkage");

  var Label$1 = {
    distance: distance$1,
    linkage: linkage$1
  };
  var Const = {
    tag: tag,
    Label: Label$1
  };

  var distance$2 = Curry._2(Record_param.flag1, distance$1, Curry._1(Record_param.Flag.required, distance));

  var linkage$2 = Curry._2(Record_param.flag1, linkage$1, Curry._1(Record_param.Flag.required, linkage));

  var Param = {
    distance: distance$2,
    linkage: linkage$2
  };

  var to_record = function to_record(distance$3, linkage$3) {
    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [distance$1,
    /* `String */
    [-976970511, distance$3]],
    /* :: */
    [
    /* tuple */
    [linkage$1,
    /* `String */
    [-976970511, linkage$3]],
    /* [] */
    0]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["heatmap.ml", 226, 30]];
    }
  };

  var of_record = function of_record(record, f) {
    var make = Curry.__2(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, distance$2)), Curry._1(Record_param.errs, linkage$2));

    return Curry._2(Record_param.parse, record, param);
  };

  var Hierarchical = {
    Const: Const,
    Param: Param,
    to_record: to_record,
    of_record: of_record
  };
  var tag$1 = "KMeans";

  var distance$3 = Curry._1(Label.named_exn, "distance");

  var numClusters = Curry._1(Label.named_exn, "numClusters");

  var Label$2 = {
    distance: distance$3,
    numClusters: numClusters
  };
  var Const$1 = {
    tag: tag$1,
    Label: Label$2
  };

  var distance$4 = Curry._2(Record_param.flag1, distance$3, Curry._1(Record_param.Flag.required, distance));

  var numClusters$1 = Curry._2(Record_param.flag1, numClusters, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$int));

  var Param$1 = {
    distance: distance$4,
    numClusters: numClusters$1
  };

  var to_record$1 = function to_record$1(distance$5, numClusters$2) {
    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [distance$3,
    /* `String */
    [-976970511, distance$5]],
    /* :: */
    [
    /* tuple */
    [numClusters,
    /* `Int */
    [3654863, numClusters$2]],
    /* [] */
    0]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["heatmap.ml", 273, 30]];
    }
  };

  var of_record$1 = function of_record$1(record, f) {
    var make = Curry.__2(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, distance$4)), Curry._1(Record_param.errs, numClusters$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var KMeans = {
    Const: Const$1,
    Param: Param$1,
    to_record: to_record$1,
    of_record: of_record$1
  };

  var of_record$2 = function of_record$2(record, hierarchical, kmeans) {
    var e = Curry._2(Record_param.Tagged.parse, record, Record_param.Arg_type.record);

    if (e[0] >= 106380200) {
      return e;
    } else {
      var match = e[1];
      var record$1 = match[1];
      var tag$2 = match[0];

      if (Bolt0_string$Bolt0.equal(tag$2, tag)) {
        return of_record(record$1, hierarchical);
      } else if (Bolt0_string$Bolt0.equal(tag$2, tag$1)) {
        return of_record$1(record$1, kmeans);
      } else {
        return (
          /* `Error */
          [106380200,
          /* :: */
          [
          /* tuple */
          [Record_param.Tagged.Const.Label.tag,
          /* Invalid */
          144245463],
          /* [] */
          0]]
        );
      }
    }
  };

  var Clustering = {
    Hierarchical: Hierarchical,
    KMeans: KMeans,
    of_record: of_record$2
  };

  var yAxisColumnName = Curry._1(Label.named_exn, "yAxisColumnName");

  var xAxisColumnNames = Curry._1(Label.named_exn, "xAxisColumnNames");

  var yAxisClustering = Curry._1(Label.named_exn, "yAxisClustering");

  var xAxisClustering = Curry._1(Label.named_exn, "xAxisClustering");

  var showOriginalData = Curry._1(Label.named_exn, "showOriginalData");

  var data = Curry._1(Label.positional_exn, 1);

  var Label$3 = {
    yAxisColumnName: yAxisColumnName,
    xAxisColumnNames: xAxisColumnNames,
    yAxisClustering: yAxisClustering,
    xAxisClustering: xAxisClustering,
    showOriginalData: showOriginalData,
    data: data
  };

  var match = Curry._1(Record_param.R.of_alist,
  /* :: */
  [
  /* tuple */
  [xAxisColumnNames,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* :: */
  [
  /* tuple */
  [yAxisColumnName,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [xAxisClustering,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [yAxisClustering,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [showOriginalData,
  /* `Bool */
  [737456202, false]],
  /* :: */
  [
  /* tuple */
  [data,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* [] */
  0]]]]]]);

  var arg;

  if (match[0] >= 17724) {
    arg = match[1];
  } else {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["heatmap.ml", 325, 32]];
  }

  var Default = {
    arg: arg
  };
  var Const$2 = {
    Label: Label$3,
    Default: Default
  };

  var yAxisColumnName$1 = Curry._2(Record_param.flag1, yAxisColumnName, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Record_param.Arg_type.string)));

  var xAxisColumnNames$1 = Curry._2(Record_param.flag1, xAxisColumnNames, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.list, Record_param.Arg_type.string)));

  var yAxisClustering$1 = Curry._2(Record_param.flag1, yAxisClustering, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Record_param.Arg_type.record)));

  var xAxisClustering$1 = Curry._2(Record_param.flag1, xAxisClustering, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Record_param.Arg_type.record)));

  var showOriginalData$1 = Curry._2(Record_param.flag1, showOriginalData, Curry._1(Record_param.Flag.required, Record_param.Arg_type.bool));

  var data$1 = Curry._2(Record_param.flag1, data, Curry._1(Record_param.Flag.required, Record_param.Arg_type.data));

  var Param$2 = {
    yAxisColumnName: yAxisColumnName$1,
    xAxisColumnNames: xAxisColumnNames$1,
    yAxisClustering: yAxisClustering$1,
    xAxisClustering: xAxisClustering$1,
    showOriginalData: showOriginalData$1,
    data: data$1
  };

  var to_record$2 = function to_record$2(yAxisColumnName$2, xAxisColumnNames$2, yAxisClustering$2, xAxisClustering$2, showOriginalData$2, data$2) {
    var option = function option(f, t) {
      if (t !== undefined) {
        return (
          /* `Some */
          [925978388, Curry._1(f, Caml_option.valFromOption(t))]
        );
      } else {
        return (
          /* Null */
          870828711
        );
      }
    };

    var list = function list(f, t) {
      return (
        /* `List */
        [848054398, Bolt0_list$Bolt0.map(f, t)]
      );
    };

    var string = function string(t) {
      return (
        /* `String */
        [-976970511, t]
      );
    };

    var record = function record(t) {
      return (
        /* `Record */
        [847309489, t]
      );
    };

    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [yAxisColumnName, option(string, yAxisColumnName$2)],
    /* :: */
    [
    /* tuple */
    [xAxisColumnNames, list(string, xAxisColumnNames$2)],
    /* :: */
    [
    /* tuple */
    [yAxisClustering, option(record, yAxisClustering$2)],
    /* :: */
    [
    /* tuple */
    [xAxisClustering, option(record, xAxisClustering$2)],
    /* :: */
    [
    /* tuple */
    [showOriginalData,
    /* `Bool */
    [737456202, showOriginalData$2]],
    /* :: */
    [
    /* tuple */
    [data, data$2],
    /* [] */
    0]]]]]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["heatmap.ml", 395, 28]];
    }
  };

  var of_record$3 = function of_record$3(record, f) {
    var make = Curry.__6(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, yAxisColumnName$1)), Curry._1(Record_param.errs, xAxisColumnNames$1)), Curry._1(Record_param.errs, yAxisClustering$1)), Curry._1(Record_param.errs, xAxisClustering$1)), Curry._1(Record_param.errs, showOriginalData$1)), Curry._1(Record_param.errs, data$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var yAxisDataTypeAvailable = function yAxisDataTypeAvailable(param) {
    if (typeof param === "number") {
      return param === -976970511;
    } else if (param[0] !== 216537025) {
      return false;
    } else {
      return param[1] === -976970511;
    }
  };

  var xAxisDataTypeAvailable = function xAxisDataTypeAvailable(param) {
    if (param !== 3654863) {
      return param === 365180284;
    } else {
      return true;
    }
  };

  var Arg = {
    Const: Const$2,
    Param: Param$2,
    to_record: to_record$2,
    of_record: of_record$3,
    yAxisDataTypeAvailable: yAxisDataTypeAvailable,
    xAxisDataTypeAvailable: xAxisDataTypeAvailable
  };

  var x = Curry._1(Label.named_exn, "x");

  var y = Curry._1(Label.named_exn, "y");

  var matrix = Curry._1(Label.named_exn, "matrix");

  var normalizedMatrix = Curry._1(Label.named_exn, "normalizedMatrix");

  var xAxisClusterLevels = Curry._1(Label.named_exn, "xAxisClusterLevels");

  var yAxisClusterLevels = Curry._1(Label.named_exn, "yAxisClusterLevels");

  var showOriginalData$2 = Curry._1(Label.named_exn, "showOriginalData");

  var Label$4 = {
    x: x,
    y: y,
    matrix: matrix,
    normalizedMatrix: normalizedMatrix,
    xAxisClusterLevels: xAxisClusterLevels,
    yAxisClusterLevels: yAxisClusterLevels,
    showOriginalData: showOriginalData$2
  };
  var Const$3 = {
    Label: Label$4
  };
  var $$Error$1 = {};

  var x$1 = Curry._2(Record_param.flag1, x, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.string)));

  var y$1 = Curry._2(Record_param.flag1, y, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.string)));

  var matrix$1 = Curry._2(Record_param.flag1, matrix, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var normalizedMatrix$1 = Curry._2(Record_param.flag1, normalizedMatrix, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var xAxisClusterLevels$1 = Curry._2(Record_param.flag1, xAxisClusterLevels, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$int))));

  var yAxisClusterLevels$1 = Curry._2(Record_param.flag1, yAxisClusterLevels, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$int))));

  var showOriginalData$3 = Curry._2(Record_param.flag1, showOriginalData$2, Curry._1(Record_param.Flag.required, Record_param.Arg_type.bool));

  var Param$3 = {
    x: x$1,
    y: y$1,
    matrix: matrix$1,
    normalizedMatrix: normalizedMatrix$1,
    xAxisClusterLevels: xAxisClusterLevels$1,
    yAxisClusterLevels: yAxisClusterLevels$1,
    showOriginalData: showOriginalData$3
  };

  var of_record$4 = function of_record$4(record, f) {
    var make = Curry.__7(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, x$1)), Curry._1(Record_param.errs, y$1)), Curry._1(Record_param.errs, matrix$1)), Curry._1(Record_param.errs, normalizedMatrix$1)), Curry._1(Record_param.errs, xAxisClusterLevels$1)), Curry._1(Record_param.errs, yAxisClusterLevels$1)), Curry._1(Record_param.errs, showOriginalData$3));

    return Curry._2(Record_param.parse, record, param);
  };

  var T = {
    Const: Const$3,
    $$Error: $$Error$1,
    Param: Param$3,
    of_record: of_record$4
  };
  return {
    Private: Private,
    $$Error: $$Error,
    Clustering: Clustering,
    Arg: Arg,
    T: T
  };
}

export { Make };
/* No side effect */